import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from './state';

export const selectFeature = createFeatureSelector<State>('candidate');

export const selectCandidateId = createSelector(
  selectFeature,
  (state: State) => state.dialog.params.candidateId,
);

export const selectOfferId = createSelector(
  selectFeature,
  (state: State) => state.dialog.params.offerId,
);

export const selectCandidateResource = createSelector(
  selectFeature,
  (state: State) => state.dialog.candidate,
);

export const selectCandidateData = createSelector(
  selectCandidateResource,
  resource => resource.data,
);

export const selectHasPendingRequestLink = createSelector(
  selectCandidateData,
  candidate => candidate!.pendingRequestLink,
);

export const selectCandidateInterviewPageState = createSelector(
  selectFeature,
  (state: State) => state.interviewPage,
);
